import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  count?: number;
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel?: string;
  className?: string;
}) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex gap-0.5 rounded-pop bg-ds-neutral-tint p-[3px] shadow-[inset_0_0_0_1px_var(--line-strong)]',
        className,
      )}
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              TYPE.control,
              'h-[34px] rounded-[9px] px-s3 whitespace-nowrap',
              selected
                ? 'bg-ds-seg-on font-semibold text-ds-teal shadow-[0_1px_2px_var(--seg-sh),0_0_0_1px_var(--line-strong)]'
                : 'font-medium text-ds-muted',
            )}
          >
            {option.label}
            {option.count != null ? (
              <span className="ml-1.5 tabular-nums text-xs font-semibold text-ds-muted">{option.count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
